<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">REKAPITULACIJA IZDATNICA</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>

      <div class="odabirDatuma" style="margin-right: 30px">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>

      <!-- OVO JE ODABIR SKLADIŠTA SIROVINA, ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <div class="odabirDatuma">
        <label [style]="{ 'margin-left': '30px' }">Skladište sirovina:</label>
        <dx-select-box
          displayExpr="sifrainaziv"
          [items]="skladistaSirovina"
          width="400"
          (onValueChanged)="onChangeSkladisteSirovina($event)"
          [style]="{ 'margin-left': '30px' }"
        >
        </dx-select-box>
      </div>

      <div class="odabirDatuma">
        <label [style]="{ 'margin-left': '30px' }">Linija:</label>
        <dx-select-box
          displayExpr="naziv"
          [items]="linije"
          width="250"
          [showClearButton]="true"
          (onValueChanged)="onChangeLinija($event)"
          [style]="{ 'margin-left': '30px' }"
        >
        </dx-select-box>
      </div>

      <div class="odabirDatuma">
        <dx-radio-group
          [items]="moguciOdabir"
          [value]="moguciOdabir[0]"
          layout="horizontal"
          (onValueChanged)="promjena($event)"
          [style]="{ 'margin-left': '30px' }"
        >
        </dx-radio-group>
      </div>

      <!-- OVO JE ZA PRAVLJENJE PDF-a, ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <div class="odabirDatuma">
        <dx-button
          *ngIf="stavkeIzdatnicaSirovina.length > 0"
          (onClick)="pdfRekapitulacijaIzdatnica()"
          [style]="{ 'margin-left': '30px', top: '-10px' }"
          >Izradi PDF</dx-button
        >
      </div>
    </div>

    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="stavkeIzdatnicaSirovina"
        [showColumnLines]="true"
        noDataText="{{ poruka }}"
        [wordWrapEnabled]="true"
        [showBorders]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0" style="padding-right: 30px">Dokumenti</h2>
            <p class="mt-0">Kliknite na dokument za prikaz detalja</p>
          </div>
        </div>

        <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[20, 30, 40]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="DV_NAZIV"
          caption="Vrsta dokumenta"
          [width]="160"
        ></dxi-column>

        <dxi-column
          dataField="ar_sifra"
          caption="Šifra"
          alignment="center"
          [width]="120"
        ></dxi-column>

        <dxi-column
          dataField="ar_naziv"
          caption="Naziv"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="kolicina"
          caption="Količina"
          alignment="right"
          format="#,##0.##"
          [width]="150"
        ></dxi-column>

        <dxi-column
          dataField="jedinicamjere_JM_SIFRA"
          caption="Jedinica mjere"
          alignment="center"
          [width]="120"
        ></dxi-column>

        <dxi-column
          dataField="cijena"
          caption="Cijena"
          alignment="right"
          format="#,##0.### €"
          [width]="150"
        ></dxi-column>

        <dxi-column
          dataField="ukupno"
          caption="Ukupno"
          alignment="right"
          format="#,##0.## €"
          [width]="150"
        ></dxi-column>

        <dxo-summary>
          <dxi-total-item 
            column="cijena" 
            summaryType="sum" 
            alignment="left" 
            displayFormat="Ukupno:">
          </dxi-total-item>
          <dxi-total-item
            column="ukupno"
            summaryType="sum"
            alignment="right"
            displayFormat="{0} €"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }">
          </dxi-total-item>
        </dxo-summary>
        
      </dx-data-grid>
    </div>
  </div>
</div>
